import React, { Component } from "react";
import { Twitter, Linkedin } from "react-feather";
import { NavLink } from "react-router-dom";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional

export default class Header extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
  }
  render() {
    return (
      <div>
        <nav
          class="navbar is-black"
          role="navigation"
          style={{
            borderBottom: "1px solid rgb(54, 54, 54)",
            marginBottom: "10px",
            paddingRight: "1%",
            paddingLeft: "1%",
          }}
          aria-label="main navigation"
        >
          <div class="navbar-brand">
            <NavLink class="navbar-item navbar-logo" to="/">
              <h1 className="title is-5 has-text-white">
                SpaceX Tracker{" "}
                <Tippy content="Live data from SpaceX">
                  <div
                    id="liveData"
                    style={{
                      backgroundColor: "#ff4444",
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      display: "inline-block",
                      marginLeft: "7px",
                      verticalAlign: "middle",
                      marginBottom: "2px",
                    }}
                  ></div>
                </Tippy>
              </h1>
            </NavLink>

            <div
              role="button"
              class={`navbar-burger burger ${this.state.isOpen && "is-active"}`}
              onClick={() => {
                this.setState({ isOpen: !this.state.isOpen });
              }}
              aria-label="menu"
              aria-expanded="false"
              data-target="navbarBasicExample"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </div>
          </div>
          <div
            id="navbarBasicExample"
            class={`navbar-menu ${this.state.isOpen && "is-active"}`}
          >
            <div class="navbar-start">
              <div
                class="navbar-item"
                style={{
                  borderRight: "1px solid rgb(54, 54, 54)",
                  marginRight: "20px",
                  marginLeft: "5px",
                  paddingRight: "25px",
                }}
              >
                <p style={{ color: "#5f5f5f" }}>
                  Get the latest SpaceX Launch updates.
                </p>
              </div>
              <NavLink
                exact
                activeClassName="active"
                className="navbar-item nav-link has-text-white"
                to="/launches"
              >
                Launches
              </NavLink>

              <NavLink
                exact
                activeClassName="active"
                className="navbar-item nav-link has-text-white"
                to="/history"
              >
                Events
              </NavLink>

              <NavLink
                exact
                activeClassName="active"
                className="navbar-item nav-link has-text-white"
                to="/roadster"
              >
                Roadster
              </NavLink>

              <NavLink
                exact
                activeClassName="active"
                className="navbar-item nav-link has-text-white"
                to="/rockets"
              >
                Rockets
              </NavLink>
            </div>

            <div class="navbar-end" style={{ marginRight: "20px" }}>
              <div class="navbar-item" style={{ display: "inline-flex" }}>
                <Tippy content="Twitter">
                  <a href="https://twitter.com/ingusjan" target="_blank">
                    <Twitter size={18} style={{ display: "flex" }} />
                  </a>
                </Tippy>
                <Tippy content="LinkedIn">
                  <a
                    style={{ marginLeft: "15px" }}
                    href="https://linkedin.com/in/ingus-jansons"
                    target="_blank"
                  >
                    <Linkedin size={18} style={{ display: "flex" }} />
                  </a>
                </Tippy>
              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}
